/* eslint-disable @reatom/unit-naming-rule */
import { reatomResource } from '@root/shared/lib'

import { fetchPairsOverviewByCreatorAction } from './creator-pairs-requests'

import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'

export const reatomCreatorPairsStats = ({
  creatorAddress,
  network,
}: {
  creatorAddress: Address
  network: Network.Network
}) => {
  const theAtom = reatomResource(async (ctx) => {
    const result = await ctx.schedule(() => {
      return fetchPairsOverviewByCreatorAction(ctx, {
        network,
        creatorAddress,
      })
    })
    return result
  })

  return theAtom
}

export type CreatorPairsStatsModel = ReturnType<typeof reatomCreatorPairsStats>
